import React, { useState } from 'react';
import { Check } from 'lucide-react';

/**
 * MultiSelectDropdown — canonical shared multi-select filter (CHA-373).
 * Extracted from the identical in-file copies in MissingBrokerData / FirstSaleErrorReport /
 * FirstSaleReview (migration of those copies is a separate ticket). Convention: an EMPTY
 * `selected` array means "no filter" and displays as `All {label}`.
 */
export default function MultiSelectDropdown({ label, options, selected, onChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOption = (option) => {
    if (selected.includes(option)) {
      onChange(selected.filter((s) => s !== option));
    } else {
      onChange([...selected, option]);
    }
  };

  const displayText = selected.length === 0
    ? `All ${label}`
    : selected.length === 1
      ? selected[0]
      : `${selected.length} selected`;

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 text-sm border border-slate-200 rounded-lg bg-white hover:bg-slate-50 min-w-[140px]"
      >
        <span className={selected.length > 0 ? 'text-slate-800' : 'text-slate-500'}>{displayText}</span>
        <svg className={`w-4 h-4 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
          <div className="absolute z-20 mt-1 w-48 bg-white border border-slate-200 rounded-lg shadow-lg max-h-60 overflow-auto">
            {options.length === 0 ? (
              <div className="px-3 py-2 text-sm text-slate-400">No options</div>
            ) : (
              options.map((option) => (
                <button
                  type="button"
                  key={option}
                  onClick={() => toggleOption(option)}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-slate-50"
                >
                  <div className={`w-4 h-4 rounded border flex items-center justify-center ${selected.includes(option) ? 'bg-blue-500 border-blue-500' : 'border-slate-300'}`}>
                    {selected.includes(option) && <Check size={12} className="text-white" />}
                  </div>
                  <span className="truncate">{option}</span>
                </button>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}
